export const translations = {
  ro: {
    nav: {
      home: "Acasă",
      about: "Despre noi",
      solutions: "Soluții",
      blog: "Blog",
      contact: "Contact",
      cta: "Solicită o discuție",
      method: "Metoda",
    },
    hero: {
      overline: "Managementul riscului & dezvoltare agricolă",
      line1: "Afacerea ta agricolă,",
      line2Pre: "sub un",
      line2Accent: "scut",
      line2Post: "strategic.",
      sub: "Ajutăm fermierii și societățile agricole să evite dificultățile financiare, să își protejeze patrimoniul și să construiască afaceri care rezistă generații.",
      scroll: "Consultanță gratuită",
    },
    form: {
      title: "Cere o analiză gratuită",
      sub: "Te sunăm noi. Confidențial, fără obligații.",
      name: "Nume și prenume",
      phone: "Telefon",
      email: "Email",
      locality: "Localitate / Județ",
      message: "Cum te putem ajuta? (opțional)",
      submit: "Trimite solicitarea",
      sending: "Se trimite...",
      success: "Solicitarea a fost trimisă. Te contactăm în cel mult 24 de ore.",
      error: "Ceva nu a funcționat. Încearcă din nou sau scrie-ne pe WhatsApp.",
      note: "Prin trimitere ești de acord cu politica de confidențialitate.",
    },
    statement: {
      overline: "De ce existăm",
      text: "Existăm pentru ca fermierii să poată lua decizii de afaceri cu aceeași încredere cu care își conduc ferma. Le protejăm patrimoniul, le întărim poziția în negocieri și îi ajutăm să construiască afaceri care rezistă generații.",
    },
    protect: {
      overline: "Metoda noastră",
      heading: "Sistemul P.R.O.T.E.C.T.®",
      sub: "Un sistem de lucru propriu, rafinat din experiența a mii de afaceri agricole analizate. Șapte etape, un singur scop: ferma ta protejată și profitabilă.",
      more: "Vezi metoda în detaliu",
      steps: [
        { letter: "P", title: "Patrimoniu", desc: "Analizăm ce trebuie protejat." },
        { letter: "R", title: "Risc", desc: "Identificăm riscurile financiare și juridice." },
        { letter: "O", title: "Optimizare", desc: "Reducem costurile și îmbunătățim structura financiară." },
        { letter: "T", title: "Trezorerie", desc: "Analizăm cash-flow-ul și lichiditatea." },
        { letter: "E", title: "Echilibru", desc: "Negociem contracte și relații comerciale mai bune." },
        { letter: "C", title: "Creștere", desc: "Planificăm investițiile și dezvoltarea." },
        { letter: "T", title: "Tranziție", desc: "Pregătim ferma pentru viitor și pentru schimbările pieței." },
      ],
    },
    method: {
      overline: "Metoda noastră",
      heading: "Sistemul P.R.O.T.E.C.T.®",
      sub: "Șapte etape clare, o singură direcție: o afacere agricolă protejată, profitabilă și pregătită pentru generații. Fiecare etapă are livrabile concrete — nu promisiuni.",
      resultLabel: "Rezultatul etapei",
      steps: [
        {
          letter: "P", title: "Patrimoniu",
          lead: "Totul începe cu o fotografie completă a averii fermei: terenuri, utilaje, stocuri, contracte, oameni. Nu poți proteja ceea ce nu ai măsurat.",
          bullets: ["Inventarierea activelor și a contractelor în derulare", "Identificarea bunurilor esențiale pentru continuitate", "Evaluarea expunerii patrimoniului personal al fermierului", "Stabilirea priorităților de protecție"],
          outcome: "O hartă clară a ceea ce contează — și ce trebuie apărat mai întâi.",
        },
        {
          letter: "R", title: "Risc",
          lead: "Fiecare fermă are punctele ei slabe. Noi le găsim înainte să devină probleme, nu după.",
          bullets: ["Audit al riscurilor financiare: datorii, garanții, scadențe", "Analiza riscurilor juridice și contractuale", "Evaluarea riscului climatic și de piață", "Ierarhizarea riscurilor după impact real"],
          outcome: "Lista riscurilor reale, ordonată, cu plan de acțiune pentru fiecare.",
        },
        {
          letter: "O", title: "Optimizare",
          lead: "Majoritatea fermelor pierd bani în locuri pe care nu le verifică niciodată. Aici îi recuperăm.",
          bullets: ["Analiza costurilor pe hectar și pe cultură", "Eliminarea cheltuielilor care nu produc", "Restructurarea proceselor interne", "Îmbunătățirea marjelor fără investiții suplimentare"],
          outcome: "O fermă care produce la fel, dar câștigă mai mult.",
        },
        {
          letter: "T", title: "Trezorerie",
          lead: "Profitul pe hârtie nu plătește ratele. Cash-flow-ul da — și el se planifică, nu se speră.",
          bullets: ["Plan de cash-flow pe 12 luni, pe calendar agricol", "Planificarea plăților în jurul campaniilor", "Pregătirea pentru vârfurile de cheltuieli", "Scenarii de lichiditate pentru anii grei"],
          outcome: "Liniște la fiecare scadență: știi din timp când și de unde vin banii.",
        },
        {
          letter: "E", title: "Echilibru",
          lead: "Contractele proaste se semnează când ești cu spatele la zid. Noi îți construim poziția de forță înainte de negociere.",
          bullets: ["Renegocierea contractelor cu furnizori", "Relația cu băncile, din poziție de forță", "Contracte de vânzare echilibrate, nu de disperare", "Pregătirea fiecărei negocieri pe cifre"],
          outcome: "Contracte care lucrează pentru tine, nu împotriva ta.",
        },
        {
          letter: "C", title: "Creștere",
          lead: "După stabilizare vine dezvoltarea — planificată, calculată, fără pariuri.",
          bullets: ["Plan de investiții cu randament calculat", "Fonduri europene aliniate la strategia fermei", "Extindere controlată, pe etape", "Repere clare de decizie pentru fiecare pas"],
          outcome: "Creștere planificată, fără supraîndatorare și fără ghicitori.",
        },
        {
          letter: "T", title: "Tranziție",
          lead: "O afacere adevărată supraviețuiește fondatorului. Pregătim ferma pentru generația următoare și pentru piețele care se schimbă.",
          bullets: ["Pregătirea fermei pentru generația următoare", "Structură care nu depinde de un singur om", "Adaptare la schimbările pieței și ale politicilor agricole", "Plan de continuitate pe termen lung"],
          outcome: "O afacere care rezistă generații — nu doar un sezon.",
        },
      ],
    },
    reviews: {
      overline: "Ce spun fermierii",
      heading: "Încredere câștigată în teren",
      items: [
        { text: "Am fost la un pas să pierd totul după doi ani grei. Au pus ordine în datorii și au renegociat cu banca. Astăzi ferma merge mai bine ca înainte.", author: "Fermier, 450 ha · Județul Ialomița" },
        { text: "Pentru prima dată am înțeles cifrele fermei mele. Fiecare decizie de atunci a fost luată cu liniște.", author: "Societate agricolă · Județul Timiș" },
        { text: "Ne-au ajutat să accesăm fonduri la care renunțaserăm. Profesioniști, discreți, mereu disponibili.", author: "Exploatație familială · Județul Dolj" },
      ],
    },
    meta: {
      home: "Scutul Fermierului | Managementul riscului agricol și dezvoltarea afacerilor agricole",
      about: "Despre noi | Scutul Fermierului",
      solutions: "Soluții pentru afaceri agricole | Scutul Fermierului",
      method: "Sistemul P.R.O.T.E.C.T.® | Scutul Fermierului",
      blog: "Blog agricol | Scutul Fermierului",
      contact: "Contact | Scutul Fermierului",
      privacy: "Politica de confidențialitate | Scutul Fermierului",
      terms: "Termeni și condiții | Scutul Fermierului",
    },
    marquee: ["AGRICULTURĂ", "MANAGEMENT", "SIGURANȚĂ", "STRATEGIE", "CONTINUITATE", "DEZVOLTARE"],
    manifesto: {
      overline: "Manifestul nostru",
      heading: "Nu vindem consultanță. Construim scuturi.",
      chapters: [
        {
          title: "Protecție",
          text: "Fermele nu cad din cauza pământului, ci din cauza deciziilor luate sub presiune. Noi stăm între tine și acea presiune: datorii, bănci, furnizori, instituții.",
        },
        {
          title: "Claritate",
          text: "Traducem birocrația, contractele și finanțele pe înțelesul fermierului. Știi exact unde ești, ce riști și ce câștigi înainte să semnezi orice.",
        },
        {
          title: "Continuitate",
          text: "Nu rezolvăm doar criza de azi. Construim structura care ține afacerea pe picioare în sezonul următor — și peste zece ani.",
        },
      ],
    },
    solutionsSection: {
      overline: "Soluții",
      heading: "Cinci fronturi. Un singur scut.",
      sub: "Fiecare problemă a fermei are o cale de rezolvare. Alege frontul pe care lupti acum.",
      cta: "Vezi soluția",
      all: "Toate soluțiile",
    },
    trust: [
      { title: "Analiză inițială gratuită", text: "Prima discuție nu costă nimic. Înțelegem situația înainte să propunem orice." },
      { title: "Răspuns în maximum 24h", text: "Când un fermier cere ajutor, timpul contează. Revenim rapid, de fiecare dată." },
      { title: "Confidențialitate totală", text: "Ce discutăm rămâne între noi. Datele fermei tale nu ajung la nimeni altcineva." },
    ],
    blogSection: {
      overline: "Din teren",
      heading: "Articole pentru fermieri care vor mai mult",
      sub: "Educație, clarificare și perspective din agricultura românească de azi.",
      cta: "Vezi toate articolele",
      read: "Citește articolul",
      minRead: "min lectură",
    },
    ctaSection: {
      heading: "Nu aștepta următoarea criză.",
      sub: "Prima discuție este gratuită și confidențială. Spune-ne ce se întâmplă la ferma ta — îți spunem sincer ce opțiuni ai.",
      primary: "Cere o analiză gratuită",
      whatsapp: "Vorbește cu noi pe WhatsApp",
    },
    about: {
      overline: "Despre noi",
      title: "Partenerul strategic al fermierului român",
      lead: "SCUTUL FERMIERULUI s-a născut dintr-o observație simplă: fermierii români muncesc enorm, dar poartă singuri riscuri pe care în alte industrii le poartă echipe întregi de specialiști.",
      p1: "Nu suntem o firmă de consultanță clasică. Nu venim cu rapoarte grele și jargon. Venim alături de fermier, în teren și la masă, și rămânem acolo până când situația este rezolvată — fie că vorbim de datorii, de o investiție majoră sau de un plan de dezvoltare pe cinci ani.",
      p2: "Lucrăm cu ferme mici, medii și mari, cu societăți agricole și cu antreprenori care vor direcție. Combinăm înțelegerea reală a agriculturii cu instrumente serioase de management al riscului și dezvoltare de business.",
      valuesOverline: "Ce ne ghidează",
      quote: "Existăm pentru ca fermierii să poată lua decizii de afaceri cu aceeași încredere cu care își conduc ferma. Le protejăm patrimoniul, le întărim poziția în negocieri și îi ajutăm să construiască afaceri care rezistă generații.",
      quoteBy: "Misiunea noastră",
    },
    solutionsPage: {
      overline: "Soluțiile noastre",
      heading: "Oricare ar fi frontul, avem un plan.",
      sub: "Cinci direcții de lucru, construite din realitatea fermelor românești. Fiecare pornește de la problema ta reală și duce spre o discuție concretă.",
      detailOverline: "Soluție",
      problem: "Provocarea",
      what: "Ce facem concret",
      steps: "Cum arată colaborarea",
      back: "Înapoi la soluții",
      breadcrumb: "Soluții",
      ctaHeading: "Sună familiar?",
      ctaSub: "Dacă situația de mai sus descrie ferma ta, hai să vorbim. Analiza inițială este gratuită.",
    },
    blog: {
      overline: "Blog",
      heading: "Claritate pentru agricultorul de azi",
      sub: "Articole care explică, nu care sperie. Context, soluții și primul pas spre o afacere mai sigură.",
      empty: "Articolele apar în curând.",
      back: "Înapoi la blog",
      notFound: "Articolul nu a fost găsit.",
    },
    contact: {
      overline: "Contact",
      heading: "Hai să vorbim despre ferma ta.",
      sub: "Spune-ne pe scurt ce se întâmplă. Revenim în maximum 24 de ore, de obicei mult mai repede.",
      phoneLabel: "Telefon",
      whatsappLabel: "WhatsApp",
      whatsappText: "Canalul cel mai rapid. Scrie-ne direct.",
      responseLabel: "Timp de răspuns",
      responseValue: "Maximum 24 de ore",
      locationLabel: "Sediu social",
      locationValue: "Str. Simion Barnuțiu 47, Ap. 2, Timișoara, jud. Timiș",
      officeLabel: "Birou București",
      officeValue: "Piața Unirii, București",
      areaLabel: "Acoperire",
      areaValue: "Toată România, discuții online sau la fermă",
      formTitle: "Trimite o solicitare",
    },
    footer: {
      tagline: "Scut strategic pentru agricultura românească. Protecție, claritate și continuitate pentru fermierii care construiesc pe termen lung.",
      navTitle: "Navigație",
      solutionsTitle: "Soluții",
      contactTitle: "Contact",
      rights: "Toate drepturile rezervate.",
      legalLine: "Site operat de EVRA ROYAL SRL · CUI 50905073 · Nr. Reg. Com. J2024042391001 · Sediu social: Str. Simion Barnuțiu 47, Ap. 2, Timișoara, jud. Timiș",
      privacy: "Politica de confidențialitate",
      terms: "Termeni și condiții",
      resourcesTitle: "Resurse",
    },
    legal: {
      privacy: {
        title: "Politica de confidențialitate",
        updated: "Ultima actualizare: iulie 2026",
        sections: [
          { h: "Operatorul datelor", p: "Operatorul datelor cu caracter personal este EVRA ROYAL SRL, CUI 50905073, înregistrată la Oficiul Național al Registrului Comerțului sub nr. J2024042391001, cu sediul social în Str. Simion Barnuțiu 47, Ap. 2, Timișoara, județul Timiș. Ne poți contacta la telefon +40 720 629 567 sau prin WhatsApp." },
          { h: "Ce date colectăm", p: "Prin formularele de pe acest site colectăm: nume și prenume, număr de telefon, adresă de email, localitate și, opțional, un mesaj despre situația fermei tale. Aceste date sunt folosite exclusiv pentru a te contacta în legătură cu solicitarea ta." },
          { h: "Cum folosim datele", p: "Datele transmise sunt preluate manual de echipa noastră și folosite doar pentru stabilirea unei discuții de consultanță. Nu vindem, nu închiriem și nu partajăm datele tale cu terți în scopuri de marketing." },
          { h: "Stocarea și securitatea", p: "Datele sunt stocate în sisteme securizate, cu acces restricționat la membrii echipei care prelucrează solicitările. Păstrăm datele doar atât cât este necesar pentru gestionarea relației cu tine." },
          { h: "Drepturile tale", p: "Conform GDPR, ai dreptul de acces, rectificare, ștergere, restricționare a prelucrării și portabilitate a datelor. Pentru exercitarea acestor drepturi, ne poți contacta telefonic sau prin WhatsApp la numărul afișat pe site." },
        ],
      },
      terms: {
        title: "Termeni și condiții",
        updated: "Ultima actualizare: iulie 2026",
        sections: [
          { h: "Datele operatorului", p: "Site-ul scutulfermierului.ro este operat de EVRA ROYAL SRL, CUI 50905073, înregistrată la Oficiul Național al Registrului Comerțului sub nr. J2024042391001, cu sediul social în Str. Simion Barnuțiu 47, Ap. 2, Timișoara, județul Timiș. Contact: +40 720 629 567." },
          { h: "Scopul site-ului", p: "Acest site are rol informativ și de prezentare a serviciilor SCUTUL FERMIERULUI. Conținutul paginilor și articolelor are caracter general și nu constituie consultanță financiară, juridică sau fiscală personalizată." },
          { h: "Serviciile descrise", p: "Descrierile soluțiilor prezentate pe site au scop orientativ. Fiecare situație agricolă este analizată individual, iar recomandările concrete se fac doar în cadrul unei colaborări stabilite cu echipa noastră." },
          { h: "Formularul de contact", p: "Trimiterea formularului nu creează o relație contractuală. Reprezintă doar o solicitare de contact, la care echipa noastră răspunde în maximum 24 de ore lucrătoare." },
          { h: "Proprietate intelectuală", p: "Conținutul acestui site (texte, imagini, identitate vizuală) aparține SCUTUL FERMIERULUI și nu poate fi reprodus fără acordul nostru scris." },
        ],
      },
    },
    common: {
      waMessage: "Bună ziua! Vă contactez de pe site-ul Scutul Fermierului. Aș dori să discutăm despre ferma mea.",
      waAria: "Deschide conversație WhatsApp",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About us",
      solutions: "Solutions",
      blog: "Blog",
      contact: "Contact",
      cta: "Request a discussion",
      method: "Our Method",
    },
    hero: {
      overline: "Agricultural risk management & business development",
      line1: "Your farming business,",
      line2Pre: "under a",
      line2Accent: "strategic",
      line2Post: "shield.",
      sub: "We help farmers and agricultural companies avoid financial difficulty, protect their patrimony, and build businesses that last for generations.",
      scroll: "Free consultation",
    },
    form: {
      title: "Request a free analysis",
      sub: "We call you. Confidential, no obligations.",
      name: "Full name",
      phone: "Phone",
      email: "Email",
      locality: "Town / County",
      message: "How can we help? (optional)",
      submit: "Send request",
      sending: "Sending...",
      success: "Your request was sent. We will contact you within 24 hours.",
      error: "Something went wrong. Please try again or message us on WhatsApp.",
      note: "By submitting you agree to the privacy policy.",
    },
    statement: {
      overline: "Why we exist",
      text: "We exist so that farmers can make business decisions with the same confidence with which they run their farm. We protect their patrimony, strengthen their position in negotiations and help them build businesses that last for generations.",
    },
    protect: {
      overline: "Our method",
      heading: "The P.R.O.T.E.C.T.® System",
      sub: "A proprietary working system, refined from the experience of thousands of analysed agricultural businesses. Seven stages, one goal: your farm protected and profitable.",
      more: "See the method in detail",
      steps: [
        { letter: "P", title: "Patrimony", desc: "We analyse what must be protected." },
        { letter: "R", title: "Risk", desc: "We identify financial and legal risks." },
        { letter: "O", title: "Optimization", desc: "We reduce costs and improve the financial structure." },
        { letter: "T", title: "Treasury", desc: "We analyse cash flow and liquidity." },
        { letter: "E", title: "Equilibrium", desc: "We negotiate better contracts and commercial relationships." },
        { letter: "C", title: "Consolidation", desc: "We plan investments and growth." },
        { letter: "T", title: "Transition", desc: "We prepare the farm for the future and for market changes." },
      ],
    },
    method: {
      overline: "Our method",
      heading: "The P.R.O.T.E.C.T.® System",
      sub: "Seven clear stages, one direction: a protected, profitable agricultural business ready for generations. Every stage has concrete deliverables — not promises.",
      resultLabel: "Stage outcome",
      steps: [
        {
          letter: "P", title: "Patrimony",
          lead: "Everything starts with a complete picture of the farm's wealth: land, machinery, stocks, contracts, people. You cannot protect what you have not measured.",
          bullets: ["Inventory of assets and running contracts", "Identification of assets essential for continuity", "Assessment of the farmer's personal patrimony exposure", "Setting protection priorities"],
          outcome: "A clear map of what matters — and what must be defended first.",
        },
        {
          letter: "R", title: "Risk",
          lead: "Every farm has its weak points. We find them before they become problems, not after.",
          bullets: ["Audit of financial risks: debts, guarantees, deadlines", "Analysis of legal and contractual risks", "Assessment of climatic and market risk", "Ranking risks by real impact"],
          outcome: "The real list of risks, ordered, with an action plan for each.",
        },
        {
          letter: "O", title: "Optimization",
          lead: "Most farms lose money in places they never check. This is where we recover it.",
          bullets: ["Cost analysis per hectare and per crop", "Elimination of non-productive expenses", "Restructuring of internal processes", "Margin improvement without additional investment"],
          outcome: "A farm that produces the same, but earns more.",
        },
        {
          letter: "T", title: "Treasury",
          lead: "Profit on paper does not pay the instalments. Cash flow does — and it is planned, not hoped for.",
          bullets: ["12-month cash-flow plan on the agricultural calendar", "Payment planning around campaigns", "Preparation for expense peaks", "Liquidity scenarios for hard years"],
          outcome: "Calm at every deadline: you know early when and where the money comes from.",
        },
        {
          letter: "E", title: "Equilibrium",
          lead: "Bad contracts are signed with your back against the wall. We build your position of strength before the negotiation.",
          bullets: ["Renegotiating supplier contracts", "The banking relationship, from a position of strength", "Balanced sales contracts, not desperate ones", "Preparing every negotiation on numbers"],
          outcome: "Contracts that work for you, not against you.",
        },
        {
          letter: "C", title: "Consolidation",
          lead: "After stabilisation comes growth — planned, calculated, without bets.",
          bullets: ["Investment plan with calculated returns", "European funds aligned with the farm's strategy", "Controlled, staged expansion", "Clear decision milestones for every step"],
          outcome: "Planned growth, without over-indebtedness and without guesswork.",
        },
        {
          letter: "T", title: "Transition",
          lead: "A true business outlives its founder. We prepare the farm for the next generation and for changing markets.",
          bullets: ["Preparing the farm for the next generation", "A structure that does not depend on one person", "Adaptation to market and agricultural policy changes", "Long-term continuity plan"],
          outcome: "A business that lasts generations — not just one season.",
        },
      ],
    },
    reviews: {
      overline: "What farmers say",
      heading: "Trust earned in the field",
      items: [
        { text: "I was one step away from losing everything after two hard years. They brought order to the debts and renegotiated with the bank. Today the farm runs better than before.", author: "Farmer, 450 ha · Ialomița County" },
        { text: "For the first time I understood my farm's numbers. Every decision since has been made calmly.", author: "Agricultural company · Timiș County" },
        { text: "They helped us access funding we had given up on. Professional, discreet, always available.", author: "Family farm · Dolj County" },
      ],
    },
    meta: {
      home: "Scutul Fermierului | Agricultural risk management & farm business development",
      about: "About us | Scutul Fermierului",
      solutions: "Solutions for agricultural businesses | Scutul Fermierului",
      method: "The P.R.O.T.E.C.T.® System | Scutul Fermierului",
      blog: "Agricultural blog | Scutul Fermierului",
      contact: "Contact | Scutul Fermierului",
      privacy: "Privacy policy | Scutul Fermierului",
      terms: "Terms and conditions | Scutul Fermierului",
    },
    marquee: ["AGRICULTURE", "MANAGEMENT", "SECURITY", "STRATEGY", "CONTINUITY", "GROWTH"],
    manifesto: {
      overline: "Our manifesto",
      heading: "We do not sell consulting. We build shields.",
      chapters: [
        {
          title: "Protection",
          text: "Farms do not fail because of the soil, but because of decisions made under pressure. We stand between you and that pressure: debt, banks, suppliers, institutions.",
        },
        {
          title: "Clarity",
          text: "We translate bureaucracy, contracts and finance into the farmer's language. You know exactly where you stand, what you risk and what you gain before you sign anything.",
        },
        {
          title: "Continuity",
          text: "We do not only fix today's crisis. We build the structure that keeps the business standing next season — and ten years from now.",
        },
      ],
    },
    solutionsSection: {
      overline: "Solutions",
      heading: "Five fronts. One shield.",
      sub: "Every farm problem has a way forward. Choose the front you are fighting on now.",
      cta: "See the solution",
      all: "All solutions",
    },
    trust: [
      { title: "Free initial analysis", text: "The first discussion costs nothing. We understand the situation before proposing anything." },
      { title: "Reply within 24h", text: "When a farmer asks for help, time matters. We get back quickly, every time." },
      { title: "Full confidentiality", text: "What we discuss stays between us. Your farm's data reaches no one else." },
    ],
    blogSection: {
      overline: "From the field",
      heading: "Articles for farmers who want more",
      sub: "Education, clarity and perspective from today's Romanian agriculture.",
      cta: "See all articles",
      read: "Read the article",
      minRead: "min read",
    },
    ctaSection: {
      heading: "Do not wait for the next crisis.",
      sub: "The first discussion is free and confidential. Tell us what is happening on your farm — we will tell you honestly what options you have.",
      primary: "Request a free analysis",
      whatsapp: "Talk to us on WhatsApp",
    },
    about: {
      overline: "About us",
      title: "The strategic partner of the Romanian farmer",
      lead: "SCUTUL FERMIERULUI was born from a simple observation: Romanian farmers work enormously hard, yet carry alone risks that in other industries are carried by entire teams of specialists.",
      p1: "We are not a classic consulting firm. We do not arrive with heavy reports and jargon. We stand beside the farmer, in the field and at the table, and we stay there until the situation is resolved — whether it is debt, a major investment or a five-year development plan.",
      p2: "We work with small, medium and large farms, with agricultural companies and with entrepreneurs who need direction. We combine a real understanding of agriculture with serious tools of risk management and business development.",
      valuesOverline: "What guides us",
      quote: "We exist so that farmers can make business decisions with the same confidence with which they run their farm. We protect their patrimony, strengthen their position in negotiations and help them build businesses that last for generations.",
      quoteBy: "Our mission",
    },
    solutionsPage: {
      overline: "Our solutions",
      heading: "Whatever the front, we have a plan.",
      sub: "Five directions of work, built from the reality of Romanian farms. Each starts from your real problem and leads to a concrete discussion.",
      detailOverline: "Solution",
      problem: "The challenge",
      what: "What we concretely do",
      steps: "What working together looks like",
      back: "Back to solutions",
      breadcrumb: "Solutions",
      ctaHeading: "Sounds familiar?",
      ctaSub: "If the situation above describes your farm, let us talk. The initial analysis is free.",
    },
    blog: {
      overline: "Blog",
      heading: "Clarity for today's farmer",
      sub: "Articles that explain, not scare. Context, solutions and the first step towards a safer business.",
      empty: "Articles are coming soon.",
      back: "Back to blog",
      notFound: "Article not found.",
    },
    contact: {
      overline: "Contact",
      heading: "Let us talk about your farm.",
      sub: "Tell us briefly what is happening. We reply within 24 hours, usually much faster.",
      phoneLabel: "Phone",
      whatsappLabel: "WhatsApp",
      whatsappText: "The fastest channel. Message us directly.",
      responseLabel: "Response time",
      responseValue: "Within 24 hours",
      locationLabel: "Registered office",
      locationValue: "Str. Simion Barnuțiu 47, Ap. 2, Timișoara, Timiș County",
      officeLabel: "Bucharest office",
      officeValue: "Piața Unirii, Bucharest",
      areaLabel: "Coverage",
      areaValue: "All of Romania, online discussions or at the farm",
      formTitle: "Send a request",
    },
    footer: {
      tagline: "A strategic shield for Romanian agriculture. Protection, clarity and continuity for farmers who build for the long term.",
      navTitle: "Navigation",
      solutionsTitle: "Solutions",
      contactTitle: "Contact",
      rights: "All rights reserved.",
      legalLine: "Site operated by EVRA ROYAL SRL · CUI 50905073 · Trade Register no. J2024042391001 · Registered office: Str. Simion Barnuțiu 47, Ap. 2, Timișoara, Timiș County",
      privacy: "Privacy policy",
      terms: "Terms and conditions",
      resourcesTitle: "Resources",
    },
    legal: {
      privacy: {
        title: "Privacy policy",
        updated: "Last updated: July 2026",
        sections: [
          { h: "The data controller", p: "The controller of personal data is EVRA ROYAL SRL, CUI 50905073, registered with the Romanian National Trade Register Office under no. J2024042391001, with registered office at Str. Simion Barnuțiu 47, Ap. 2, Timișoara, Timiș County. You can contact us at +40 720 629 567 or via WhatsApp." },
          { h: "What data we collect", p: "Through the forms on this site we collect: full name, phone number, email address, locality and, optionally, a message about your farm's situation. This data is used exclusively to contact you about your request." },
          { h: "How we use the data", p: "Submitted data is picked up manually by our team and used only to set up a consulting discussion. We do not sell, rent or share your data with third parties for marketing purposes." },
          { h: "Storage and security", p: "Data is stored in secure systems, with access restricted to the team members handling requests. We keep data only as long as necessary to manage the relationship with you." },
          { h: "Your rights", p: "Under GDPR you have the right of access, rectification, erasure, restriction of processing and data portability. To exercise these rights, contact us by phone or WhatsApp at the number shown on the site." },
        ],
      },
      terms: {
        title: "Terms and conditions",
        updated: "Last updated: July 2026",
        sections: [
          { h: "Operator details", p: "The website scutulfermierului.ro is operated by EVRA ROYAL SRL, CUI 50905073, registered with the Romanian National Trade Register Office under no. J2024042391001, with registered office at Str. Simion Barnuțiu 47, Ap. 2, Timișoara, Timiș County. Contact: +40 720 629 567." },
          { h: "Purpose of the site", p: "This site is informational, presenting the services of SCUTUL FERMIERULUI. The content of pages and articles is general in nature and does not constitute personalised financial, legal or tax advice." },
          { h: "The services described", p: "The descriptions of solutions on the site are indicative. Every agricultural situation is analysed individually, and concrete recommendations are made only within an established collaboration with our team." },
          { h: "The contact form", p: "Submitting the form does not create a contractual relationship. It is only a contact request, to which our team responds within 24 working hours." },
          { h: "Intellectual property", p: "The content of this site (texts, images, visual identity) belongs to SCUTUL FERMIERULUI and may not be reproduced without our written consent." },
        ],
      },
    },
    common: {
      waMessage: "Hello! I am contacting you from the Scutul Fermierului website. I would like to discuss my farm.",
      waAria: "Open WhatsApp conversation",
    },
  },
};
